<template>
  <div
    :class="modifiers"
    class="c-control c-control__select"
    v-click-outside="onClickOutside"
  >
    <label :for="name" class="c-control__select-raw">
      <select
        :name="name"
        :value="value"
        tabindex="-1"
        @change="onChange($event)"
      >
        <option key="" value="">choose configuration</option>
        <option
          :key="option.value"
          :value="option.value"
          v-for="option in filteredOptions"
        >
          {{ option.text }}
        </option>
      </select>
    </label>
    <!--Auto complete is off until we add styles support for it (currently it does ruin the style)-->
    <input
      :id="id"
      :placeholder="label"
      :value="inputValue"
      @blur="onInputBlur"
      @focus="onInputFocus"
      @input="onInputChange($event.target.value)"
      @keydown.tab="onTabKey"
      @keyup.enter="onEnterKey"
      autocomplete="off"
      class="c-control__input"
      ref="selectInput"
      type="text"
    />
    <label :style="{'pointer-events':activeLabel===''?'none':'all'}" :for="activeLabel===null?id:activeLabel" class="c-control__label">{{ label }}</label>
    <div
      :class="{ 'c-control__select__arrow--active': active }"
      @click="onArrowClick"
      class="c-control__select__arrow"
    >
      <font-awesome-icon icon="chevron-down"></font-awesome-icon>
    </div>

    <div class="c-control__select__dropdown" v-if="active">
      <template v-if="filteredOptions.length > 0">
        <div
          :class="{
            'c-control__select__dropdown__option--highlighted':
              highlightedOption && highlightedOption.value === option.value
          }"
          @mouseover="highlightedOption = option"
          class="c-control__select__dropdown__option"
          v-for="option in filteredOptions"
        >
          {{ option.text }}
        </div>
      </template>
      <div v-else>
        <div class="c-control__select__dropdown__option">
          No result found
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Configure from "../../mixins/configure";

export default {
  name: "base-select",
  props: {
    selectConfigParams: {
      type: Object
    },
    size: {
      type: String,
      validator: function(value) {
        return ["small", "medium", "large"].indexOf(value) !== -1;
      }
    },
    label: {
      type: String,
      required: true
    },
    value: {
      default: null
    },
    options: {
      type: Array, // [{value, text}]
      required: true
    },
    id: {
      type: String
    },
    name: {
      type: String
    }
  },
  data() {
    return {
      activeLabel:null,
      inputValue: null,
      active: false,
      highlightedOption: null,
      readyToHandleClick: true,
      focused: false,
      selectedOption: null
    };
  },
  mounted() {
    this.selectedOption = this.value
      ? this.options.find(option => option.value === this.value)
      : null;
    this.inputValue = this.selectedOption ? this.selectedOption.text : null;
  },
  computed: {
    filteredOptions() {
      return this.options.filter(option => {
        if (!this.inputValue || this.inputValue === this.selectedOption?.text) return true;
        else {
          return (
            option.text.toLowerCase().indexOf(this.inputValue.toLowerCase()) ===
            0
          );
        }
      });
    },
    modifiers() {
      return {
        "c-control--medium": this.size === "medium",
        "c-control__select--open": this.active,
        "c-control__select--empty": !this.value
      };
    }
  },
  methods: {
    onchange(event) {
      //console.log(event.target.value);
    },
    edit() {
      if (this.task == "switch config") {
        if (this.chosenConfig == "") {
          return;
        }

        if (this.chosenConfig == this.$currentConfig.id) {
          this.$store.commit("editingConfig", { editing: true });
          // this.$router.push(`/?config_id=${this.chosenConfig}#config`)
          this.chosenConfig = "";
          this.$parent.$emit("changeActivePanel", "general");
          return;
        }

        this.$store.commit("toggleConfigLoading");

        this.$router.push({
          path: `/?config_id=${this.chosenConfig}`,
          hash: "config"
        });

        location.reload(true);
      }
    },
    /**
     * User Interactions
     */
    onArrowClick() {
      if (this.readyToHandleClick && !this.active) this.open();
    },
    onClickOutside() {
      if (!this.active) return;
      this.select();
      this.close();
    },
    onTabKey() {
      this.select();
      this.close();
    },
    onEnterKey() {
      this.select();
      this.close();
    },

    /**
     * Actions
     */
    open() {
      this.active = true;
      if (!this.focused) this.$refs.selectInput.focus();
      this.$emit("toggle", true);
    },
    close() {
      this.active = false;
      if (this.focused) this.$refs.selectInput.blur();
      this.$emit("toggle", false);
    },
    select() {
      if (
        this.highlightedOption &&
        (!this.selectedOption ||
          this.selectedOption.value !== this.highlightedOption.value)
      )
        this.selectedOption = this.highlightedOption;
      else return;

      this.$emit("input", this.selectedOption.value);

      this.$emit("change", this.selectedOption.value);
    },
    debounceClick() {
      this.readyToHandleClick = false;
      setTimeout(() => {
        this.readyToHandleClick = true;
      }, 250);
    },
    setupSelectedOptionWith(value) {
      if (value !== null) {
        this.selectedOption = this.options.find(
          option => option.value === value
        );
        this.inputValue = this.selectedOption.text;
      } else {
        this.selectedOption = null;
        this.inputValue = null;
      }
    },

    /**
     * Internal Private Events Handlers
     */
    onInputFocus() {
      this.activeLabel="";
      this.focused = true;
      //this.inputValue = "";
      if (!this.active) this.open();
      this.debounceClick();
    },
    onInputBlur() {
      this.focused = false;
      this.select();
      this.inputValue = this.selectedOption ? this.selectedOption.text : null;
      this.activeLabel=this.id;
      if (this.active) this.close();
      this.debounceClick();
    },
    onInputChange(value) {
      this.inputValue = value;
      this.highlightedOption = this.filteredOptions && this.filteredOptions[0];
    }
  },
  watch: {
    value(value) {
      // check if the values are passed correctly then apply the switch-config handler
      // starting the switch configuration handler
      if (this.selectConfigParams?.task == "switch config") {
        if (this.selectConfigParams.chosenConfig == "") {
          return;
        }

        if (
          this.selectConfigParams.chosenConfig ==
          this.selectConfigParams.currentConfigId
        ) {
          this.$store.commit("editingConfig", { editing: true });
          // this.$router.push(`/?config_id=${this.chosenConfig}#config`)
          this.selectConfigParams.chosenConfig = "";
          this.$parent.$emit("changeActivePanel", "general");
          return;
        }

        this.$store.commit("toggleConfigLoading");

        this.$router.push({
          path: `/?config_id=${this.selectConfigParams.chosenConfig}`,
          hash: "config"
        });

        location.reload(true);
      }
      // end of the switch configuration Handler

      if (
        value !== null &&
        (!this.selectedOption || this.selectedOption.value !== value)
      ) {
        this.setupSelectedOptionWith(value);
      } else if (value === null && this.selectedOption) {
        this.setupSelectedOptionWith(null);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
// Temp import to prevent the app.vue styles from overriding c-control styles
@import "../../../../../sass/embeds/infinity/store/components/form";
</style>
